import { useQuery } from '@tanstack/react-query';
import { fetchLookupLocations } from '@api';

const importOrder = ['Region', 'Country', 'Port'];

function locationSort(a, b) {
  return a?.name?.localeCompare(b?.name);
}

const sortByLocation = importOrder.reduce((obj, item, index) => {
  return {
    ...obj,
    [item]: index
  };
}, {});
export const useLookupLocationsQuery = () => {
  return useQuery({
    queryKey: ['lookupLocations'],
    placeholderData: [],
    queryFn: ({ signal }) => {
      return fetchLookupLocations(signal)
        .then((resp) =>
          resp.sort(locationSort)?.sort((a, b) => sortByLocation[a.type] - sortByLocation[b.type])
        )
        .catch(() => []);
    }
  });
};
